import React, { useState } from "react";
import { FaSignInAlt, FaUser, FaLock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import api from "../../utils/intercepter/axiosConfig.js";
import logo from "../../assets/mf2.jpg"

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState(null); // contenu du message
  const [messageType, setMessageType] = useState("danger"); // "success", "danger", etc.

  const navigate = useNavigate();

  const validForms = () => {
    const newErrors = {};
    if (!username.trim()) newErrors.username = "Le nom d'utilisateur est obligatoire.";
    if (!password.trim()) {
      newErrors.password = "Mot de passe obligatoire.";
    } else if (password.length < 5) {
      newErrors.password = "Le mot de passe n'est pas valide.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); 

    if (!validForms()) return;

    try {
      const response = await api.post("/auth/login", { username, password });

      if (response.data.status) {
        localStorage.setItem("token", response.data.token);
        setMessage("Connexion réussie !");
        setMessageType("success");
        setTimeout(() => navigate("/verify-tf"), 1000); // Redirection avec délai
      } else {
        setMessage(response.data.message);
        setMessageType("danger");
      }
      
    } catch (error) {
      const errMsg = error?.response?.data?.message || "Erreur de connexion au serveur.";
      setMessage(errMsg);
      setMessageType("danger");
    }
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-white" style={{ borderBottom: '6px solid #198754' }}>
        <div className="container-fluid">
          <a className="navbar-brand" href="#">
            <img src={logo} style={{ width: '300px' }} alt="logo" />
          </a>
        </div>
      </nav>

      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title mb-4 text-center">
                  <FaSignInAlt className="text-dark fw-bold me-2" />
                  Page Connexion
                </h5>
                <hr />

                {message && (
                  <div className={`alert alert-${messageType} text-center`} role="alert">
                    {message}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="form-group mb-3 position-relative">
                    <label htmlFor="identifiant_username">Nom d'utilisateur</label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <FaUser />
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        id="identifiant_username"
                        value={username}
                        placeholder="Entrez nom d'utilisateur"
                        onChange={(e) => setUsername(e.target.value)}
                        required
                      />
                    </div>
                    {errors.username && <span className="text-danger">{errors.username}</span>}
                  </div>

                  <div className="form-group mb-3 position-relative">
                    <label htmlFor="mot_de_passe">Mot de passe</label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <FaLock />
                      </span>
                      <input
                        type="password"
                        className="form-control"
                        id="mot_de_passe"
                        value={password}
                        placeholder="Entrez votre mot de passe"
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>
                    {errors.password && <span className="text-danger">{errors.password}</span>}
                  </div>

                  <div className="d-grid">
                    <button type="submit" className="btn btn-success btn-sm">
                      Connecter
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
